export default __webpack_public_path__ + "static/media/f-04.9d6dd828.jpg";